import type { ReactNode, SVGProps } from "react";

export function DashboardIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 14 14"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.43343 0.600098H4.76676C4.98778 0.600098 5.19974 0.665946 5.35602 0.783156C5.5123 0.900366 5.6001 1.05934 5.6001 1.2251V4.9751C5.6001 5.14086 5.5123 5.29983 5.35602 5.41704C5.19974 5.53425 4.98778 5.6001 4.76676 5.6001H1.43343C1.21242 5.6001 1.00046 5.53425 0.844175 5.41704C0.687895 5.29983 0.600098 5.14086 0.600098 4.9751V1.2251C0.600098 1.05934 0.687895 0.900366 0.844175 0.783156C1.00046 0.665946 1.21242 0.600098 1.43343 0.600098Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M8.43343 0.600098H11.7668C11.9878 0.600098 12.1997 0.665946 12.356 0.783156C12.5123 0.900366 12.6001 1.05934 12.6001 1.2251V4.9751C12.6001 5.14086 12.5123 5.29983 12.356 5.41704C12.1997 5.53425 11.9878 5.6001 11.7668 5.6001H8.43343C8.21242 5.6001 8.00046 5.53425 7.84418 5.41704C7.6879 5.29983 7.6001 5.14086 7.6001 4.9751V1.2251C7.6001 1.05934 7.6879 0.900366 7.84418 0.783156C8.00046 0.665946 8.21242 0.600098 8.43343 0.600098Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M1.43343 7.6001H4.76676C4.98778 7.6001 5.19974 7.66595 5.35602 7.78316C5.5123 7.90037 5.6001 8.05934 5.6001 8.2251V11.9751C5.6001 12.1409 5.5123 12.2998 5.35602 12.417C5.19974 12.5343 4.98778 12.6001 4.76676 12.6001H1.43343C1.21242 12.6001 1.00046 12.5343 0.844175 12.417C0.687895 12.2998 0.600098 12.1409 0.600098 11.9751V8.2251C0.600098 8.05934 0.687895 7.90037 0.844175 7.78316C1.00046 7.66595 1.21242 7.6001 1.43343 7.6001Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M8.43343 7.6001H11.7668C11.9878 7.6001 12.1997 7.66595 12.356 7.78316C12.5123 7.90037 12.6001 8.05934 12.6001 8.2251V11.9751C12.6001 12.1409 12.5123 12.2998 12.356 12.417C12.1997 12.5343 11.9878 12.6001 11.7668 12.6001H8.43343C8.21242 12.6001 8.00046 12.5343 7.84418 12.417C7.6879 12.2998 7.6001 12.1409 7.6001 11.9751V8.2251C7.6001 8.05934 7.6879 7.90037 7.84418 7.78316C8.00046 7.66595 8.21242 7.6001 8.43343 7.6001Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
